import { useActiveUserContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { AmrDataRequestAdminTabsComponent } from './amr-data-request-admin-tabs.component';
import { AmrDataRequestRequesterTabsComponent } from './amr-data-request-requester-tabs.component';
import { AmrDataRequestDcTabsComponent } from './amr-data-request-dc-tabs.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export const AmrDataRequestTabsContainerComponent = () => {
    const { hasPermission } = useActiveUserContext();
    const { dataRequest, organizations } = useDataRequestContext();
    const { userIsContributorOrIRPApprover } = useDataRequestPermissionsContext();
    const isContributorOrIRPApprover = userIsContributorOrIRPApprover(dataRequest, organizations);

    //TODO PERMFE - redo with permissions+
    if (hasPermission(PermissionsEnum.DrActAdv)) {
        return <AmrDataRequestAdminTabsComponent />;
    }

    if (isContributorOrIRPApprover) {
        return <AmrDataRequestDcTabsComponent />;
    }

    return <AmrDataRequestRequesterTabsComponent />;
};
